/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'

import { Button, makeStyles } from '@material-ui/core'

import { Collapse } from 'components'
import Footer from './../Footer'
import CollapseHeader from './components/CollapseHeader'
import CollapseBody from './components/CollapseBody'
import useContract from 'hooks/useContract'
import useCollapse from 'hooks/useCollapse'
import styles from './styles'

const useStyles = makeStyles(styles)

const Plan = () => {
  const classes = useStyles()
  const { nextStep } = useContract()
  const collapse = useCollapse()

  React.useEffect(() => {
    if (collapse.data && collapse.data.length) {
      return
    }

    collapse.add({
      plan: null,
      periodicity: '',
      quantity: '',
      price: 0,
      contractPlanEntries: [{ quantity: '', price: 0 }],
      collapseSettings: { edit: true },
    })
  }, [])

  const handleClickAddPlan = () => {
    collapse.add({
      plan: null,
      periodicity: '',
      quantity: '',
      price: 0,
      contractPlanEntries: [{ quantity: '', price: 0 }],
      collapseSettings: { edit: true },
    })
  }

  const handleClickNextButton = () => nextStep()

  const disabledAddButton = collapse.data.some(
    contractPlan => contractPlan.collapseSettings.edit,
  )

  const disabledNextButton = collapse.data.some(
    item => item.collapseSettings.edit,
  )

  return (
    <>
      <div className={classes.plans}>
        <div className={classes.buttonAddPlan}>
          <Button
            variant="outlined"
            color="primary"
            disabled={disabledAddButton}
            onClick={handleClickAddPlan}
          >
            Adicionar plano
          </Button>
        </div>

        <Collapse collapseHeader={CollapseHeader} collapseBody={CollapseBody} />
      </div>
      <Footer
        nextButtonProps={{
          disabled: disabledNextButton,
          onClick: handleClickNextButton,
        }}
      />
    </>
  )
}

export default Plan
